// Mutation hook - odpowiedz na konkretna wiadomosc Notify (REPLY / REPLY_ALL).
// POST /api/ui/sales-crm/mailbox/reply-to-notify/{notifyId}
// Sprint 3 v4.1. Backend orkiestruje pre-fill (To/Cc/Subject + In-Reply-To/References).

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IPostReplyToNotifyRequest,
  IPostReplyToNotifyResponse
} from 'api/types/composer';

export interface IUsePostReplyToNotifyParams {
  notifyId: number;
  /** Opcjonalne - jesli podany, hook invaliduje notify-by-deal po sukcesie aby timeline odswiezylo. */
  dealId?: number;
  /** Opcjonalne - jesli podany, hook invaliduje notify-by-thread po sukcesie. */
  threadId?: number;
  body: IPostReplyToNotifyRequest;
}

const postReplyToNotify = (
  params: IUsePostReplyToNotifyParams
): Promise<IPostReplyToNotifyResponse> =>
  axios.post(`/sales-crm/mailbox/reply-to-notify/${params.notifyId}`, params.body);

export const usePostReplyToNotify = (
  options?: UseMutationOptions<IPostReplyToNotifyResponse, IError, IUsePostReplyToNotifyParams>
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostReplyToNotifyResponse, IError, IUsePostReplyToNotifyParams>(
    postReplyToNotify,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        if (variables.dealId) {
          await queryClient.invalidateQueries(['sales-crm-notify', 'by-deal', variables.dealId]);
          await queryClient.invalidateQueries(['sales-crm-notify', 'threads', 'by-deal', variables.dealId]);
        }
        if (variables.threadId) {
          await queryClient.invalidateQueries(['sales-crm-notify', 'by-thread', variables.threadId]);
        }
        options?.onSuccess?.(data, variables, context);
      }
    }
  );
};
